<template>
<div>
  <select v-model="selected">
    <option :value="null" disabled>Please select one</option>
    <option
      v-for="lesson of lessons"
      :key="lesson.scheduleId"
      :value="lesson.scheduleId"
    >
      {{ lesson.date.format('YYYY/MM/DD') }} Period {{ lesson.period }}
      {{ lesson.campus.name }} {{ lesson.course.name }} {{ lesson.level.name }}
    </option>
  </select>
</div>
</template>

<script lang="ts">
import _ from 'lodash'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Lesson, LessonsSearchConditions } from '@/store/lessons/types'
import { Tutor } from '@/store/tutors/types'
import { Moment } from 'moment'
import { RootState } from '@/store/types'

@Component
export default class SelectLessonInput extends Vue {
  @Prop() value!: Lesson

  @Prop({ required: true }) tutor!: Tutor

  @Prop({ required: true }) date!: Moment

  created() {
    const conditions: LessonsSearchConditions = {
      date: this.date || null,
      tutor: this.tutor || null,
    }
    this.$store.dispatch('fetchLessons', conditions)
  }

  private get selected(): string|undefined {
    return this.value?.scheduleId
  }

  private set selected(lessonId: string|undefined) {
    const lesson = this.$store.getters.findLessonByScheduleId(lessonId)
    this.$emit('input', lesson)
  }

  private get lessons(): Lesson[] {
    return (this.$store.state as RootState).lessons.lessons
  }
}
</script>

<style scoped>
  select{
    padding: 5px;
    border: 1px solid #AAAFB6;
    border-radius: 30px;
    width: 100%;
  }
</style>
